import { HttpMethods, sendRequest } from "../util/ApiHelper";

const CONTROLLER_NAME = "EquipmentInspections";

export interface GetLinkedEquipmentInspectionsParams {
  equipSerialId: string;
  equipSerialInd: string;
}

export const getLinkedEquipmentInspections = async (
  params: GetLinkedEquipmentInspectionsParams
) => {
  const equipSerialInd =
    params.equipSerialInd === "s" ? "s" : "e";

  return await sendRequest(
    HttpMethods.GET,
    `${CONTROLLER_NAME}/GetLinkedInspections`,
    undefined,
    {
      equipSerialId: params.equipSerialId,
      equipSerialInd,
    }
  );
};

